import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=16e07d10&scoped=true&"
import script from "./CurrencyInput.vue?vue&type=script&lang=js&"
export * from "./CurrencyInput.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyInput.vue?vue&type=style&index=0&id=16e07d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e07d10",
  null
  
)

export default component.exports